const levels = [
  {
    level: "1",
    name: "challenge-operator-one",
    firebaseId: "yvF9Okvglg7VIOkZllit",
    title: "Operator 1",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`
  },
  {
    level: "2",
    name: "challenge-operator-two",
    firebaseId: "KVBCzKkQLY14Lmw6eg2J",
    title: "Operator 2",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`
  },
  {
    level: "3",
    name: "challenge-operator-three",
    firebaseId: "CjdiD5jVe7UIGWgpGPrS",
    title: "Operator 3",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`
  },
  {
    level: "4",
    name: "challenge-operator-four",
    firebaseId: "ohxuna8hR0pm11YKHFUm",
    title: "Operator 4",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Math">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_modulo">
                    <value name="DIVIDEND"></value>
                    <value name="DIVISOR"> </value>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`
  },
  {
    level: "5",
    name: "challenge-operator-five",
    firebaseId: "XUJLtqKIg7iqmESmIssZ",
    title: "Operator 5",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
              <category name="Math">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
                <block type="math_random_int">
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                </block>
              </category>
              <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
            </xml>`
  },
  {
    level: "6",
    name: "challenge-conditional-one",
    firebaseId: "b6NnA4Ub6nNRdz65FciY",
    title: "Conditional 1",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Math">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "7",
    name: "challenge-conditional-two",
    firebaseId: "Q55momIbMkusYFKd3HYx",
    title: "Conditional 2",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Math">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "8",
    name: "challenge-conditional-three",
    firebaseId: "81l0QUWVEzguJgeCX5tw",
    title: "Conditional 3",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Math">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "9",
    name: "challenge-conditional-four",
    firebaseId: "uSqEW0EWgLIUTkOoSPDu",
    title: "Conditional 4",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "10",
    name: "challenge-conditional-five",
    firebaseId: "iQP6OvGgnHAY88RwJOIO",
    title: "Conditional 5",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "11",
    name: "challenge-conditional-six",
    firebaseId: "jRPqxMPaS9eLAKDr3fua",
    title: "Conditional 6",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_modulo">
                    <value name="DIVIDEND">
                    </value>
                    <value name="DIVISOR">
                    </value>
                  </block>
                </category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                  <block type="logic_operation">
                    <field name="OP">AND</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "12",
    name: "challenge-conditional-seven",
    firebaseId: "OATGk7wg97MRTGyPTfHV",
    title: "Conditional 7",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_modulo">
                    <value name="DIVIDEND">
                    </value>
                    <value name="DIVISOR">
                    </value>
                  </block>
                </category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                  <block type="logic_operation">
                    <field name="OP">AND</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "13",
    name: "challenge-conditional-eight",
    firebaseId: "XzgJSTqyudg3jYJDyY3f",
    title: "Conditional 8",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_modulo">
                    <value name="DIVIDEND">
                    </value>
                    <value name="DIVISOR">
                    </value>
                  </block>
                </category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                  <block type="logic_operation">
                    <field name="OP">AND</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
              </xml>`,
    workspace: `<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
                  <variables>
                    <variable id="uVaB!p2Ru1+];/u?R~sf">myNumber</variable>
                    <variable id="#QBM~NrYmk]QtaW:7X#T">result</variable>
                  </variables>
                  <block type="procedures_defreturn" id="tySL|5st/Bi)rbx_O[KE" x="38" y="38">
                    <mutation>
                      <arg name="myNumber" varid="uVaB!p2Ru1+];/u?R~sf"></arg>
                    </mutation>
                    <field name="NAME">checkNumber</field>
                    <comment pinned="false" h="80" w="160">Describe this function...</comment>
                    <statement name="STACK">
                      <block type="variables_set" id="v(dt8,@SDJsnd^CJ0)(n">
                        <field name="VAR" id="#QBM~NrYmk]QtaW:7X#T">result</field>
                        <value name="VALUE">
                          <block type="logic_null" id="LTDc:51Ba/V?V_U!{JeT"></block>
                        </value>
                      </block>
                    </statement>
                    <value name="RETURN">
                      <block type="variables_get" id="R5LoLAtTxa6^$woO8!k_">
                        <field name="VAR" id="#QBM~NrYmk]QtaW:7X#T">result</field>
                      </block>
                    </value>
                  </block>
                </xml>`
  },
  {
    level: "14",
    name: "challenge-loop-one",
    firebaseId: "CDJMPEqh0fg3Sc9BjeYA",
    title: "Loop 1",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "15",
    name: "challenge-loop-two",
    firebaseId: "MS95TggW9iQM3mvsmkm9",
    title: "Loop 2",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "16",
    name: "challenge-loop-three",
    firebaseId: "stoqoHmWOc6duQ1TX2QK",
    title: "Loop 3",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                  <field name="OP">ADD</field>
                </block>
                </category>
              </xml>`
  },
  {
    level: "17",
    name: "challenge-loop-four",
    firebaseId: "CUbNRdo2DD4YWV4v2uK3",
    title: "Loop 4",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                  <block type="math_modulo">
                    <value name="DIVIDEND">
                    </value>
                    <value name="DIVISOR">
                    </value>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "18",
    name: "challenge-loop-five",
    firebaseId: "qdBr8pJR4LMcXnmCeGTS",
    title: "Loop 5",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "19",
    name: "challenge-loop-six",
    firebaseId: "V3nlEslAwg27fKPe4Qz4",
    title: "Loop 6",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "20",
    name: "challenge-loop-seven",
    firebaseId: "eO6J3lWNZwuar289VGlk",
    title: "Loop 7",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "21",
    name: "challenge-loop-eight",
    firebaseId: "17MzgJjF4cjMSr9jshje",
    title: "Loop 8",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_whileUntil">
                  <field name="MODE">WHILE</field>
                </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Logic" colour="#5b80a5">
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "22",
    name: "challenge-loop-nine",
    firebaseId: "B1EOexAxlbMUqjYHStW6",
    title: "Loop 9",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_whileUntil">
                  <field name="MODE">WHILE</field>
                </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text_print"></block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Logic" colour="#5b80a5">
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "23",
    name: "challenge-function-one",
    firebaseId: "nnoXCPbZnnAzeVhfK8pT",
    title: "Function 1",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
                <category name="Functions" colour="#995ba5" custom="PROCEDURE"></category>
              </xml>`
  },
  {
    level: "24",
    name: "challenge-function-two",
    firebaseId: "TUD0Se7bh7YrIKgSRY4C",
    title: "Function 2",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
                <category name="Functions" colour="#995ba5" custom="PROCEDURE"></category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "25",
    name: "challenge-function-three",
    firebaseId: "JLU0uVVyRdBpADG8q2WK",
    title: "Function 3",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
                <category name="Functions" colour="#995ba5" custom="PROCEDURE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "26",
    name: "challenge-function-four",
    firebaseId: "ibSgibjcIMqBrCr9n4B4",
    title: "Function 4",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
                <category name="Functions" colour="#995ba5" custom="PROCEDURE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "27",
    name: "challenge-function-five",
    firebaseId: "o9I2RRBVea4H8w8N33d7",
    title: "Function 5",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
                <category name="Functions" colour="#995ba5" custom="PROCEDURE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                </category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "28",
    name: "challenge-list-one",
    firebaseId: "xOtWakjKXSsk3MR2nRex",
    title: "List 1",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                      <shadow type="text">
                        <field name="TEXT">abc</field>
                      </shadow>
                    </value>
                  </block>
                </category>
                <category name="Lists" colour="#745ba5">
                  <block type="lists_create_with">
                    <mutation items="3"></mutation>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "29",
    name: "challenge-list-two",
    firebaseId: "gFGbnwUEqxuUQxqYiJgh",
    title: "List 2",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                      <shadow type="text">
                        <field name="TEXT">abc</field>
                      </shadow>
                    </value>
                  </block>
                </category>
                <category name="Lists" colour="#745ba5">
                  <block type="lists_create_with">
                    <mutation items="3"></mutation>
                  </block>
                  <block type="lists_setIndex">
                    <mutation at="true"></mutation>
                    <field name="MODE">SET</field>
                    <field name="WHERE">FROM_START</field>
                    <value name="LIST">
                      <block type="variables_get">
                        <field name="VAR">list</field>
                      </block>
                    </value>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "30",
    name: "challenge-list-three",
    firebaseId: "vjPyu8bq93pSeLxYmmxv",
    title: "List 3",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                      <shadow type="text">
                        <field name="TEXT">abc</field>
                      </shadow>
                    </value>
                  </block>
                </category>
                <category name="Lists" colour="#745ba5">
                  <block type="lists_create_with">
                    <mutation items="3"></mutation>
                  </block>
                  <block type="lists_setIndex">
                    <mutation at="true"></mutation>
                    <field name="MODE">SET</field>
                    <field name="WHERE">FROM_START</field>
                    <value name="LIST">
                      <block type="variables_get">
                        <field name="VAR">list</field>
                      </block>
                    </value>
                  </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "31",
    name: "challenge-list-four",
    firebaseId: "oI4pDQgeGRKFKFdNxart",
    title: "List 4",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                      <shadow type="text">
                        <field name="TEXT">abc</field>
                      </shadow>
                    </value>
                  </block>
                </category>
                <category name="Lists" colour="#745ba5">
                  <block type="lists_create_with">
                    <mutation items="0"></mutation>
                  </block>
                  <block type="lists_setIndex">
                    <mutation at="true"></mutation>
                    <field name="MODE">SET</field>
                    <field name="WHERE">FROM_START</field>
                    <value name="LIST">
                      <block type="variables_get">
                        <field name="VAR">list</field>
                      </block>
                    </value>
                  </block>
                </category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "32",
    name: "challenge-list-five",
    firebaseId: "7DBw7l1ZVsaKT69oZfE0",
    title: "List 5",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                      <shadow type="text">
                        <field name="TEXT">abc</field>
                      </shadow>
                    </value>
                  </block>
                </category>
                <category name="Lists" colour="#745ba5">
                  <block type="lists_create_with">
                    <mutation items="3"></mutation>
                  </block>
                  <block type="lists_getIndex">
                    <mutation statement="false" at="true"></mutation>
                    <field name="MODE">GET</field>
                    <field name="WHERE">FROM_START</field>
                    <value name="VALUE">
                      <block type="variables_get">
                        <field name="VAR">list</field>
                      </block>
                    </value>
                  </block>
                </category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
              </xml>`
  },
  {
    level: "33",
    name: "challenge-list-six",
    firebaseId: "8GLDCXwxQ820A8PgQeFt",
    title: "List 6",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print">
                    <value name="TEXT">
                      <shadow type="text">
                        <field name="TEXT">abc</field>
                      </shadow>
                    </value>
                  </block>
                </category>
                <category name="Lists" colour="#745ba5">
                  <block type="lists_create_with">
                    <mutation items="3"></mutation>
                  </block>
                  <block type="lists_getIndex">
                    <mutation statement="false" at="true"></mutation>
                    <field name="MODE">GET</field>
                    <field name="WHERE">FROM_START</field>
                    <value name="VALUE">
                      <block type="variables_get">
                        <field name="VAR">list</field>
                      </block>
                    </value>
                  </block>
                  <block type="lists_setIndex">
                    <mutation at="true"></mutation>
                    <field name="MODE">SET</field>
                    <field name="WHERE">FROM_START</field>
                    <value name="LIST">
                      <block type="variables_get">
                        <field name="VAR">list</field>
                      </block>
                    </value>
                  </block>
                </category>
                <category name="Loops" colour="#5ba55b">
                <block type="controls_for">
                  <field name="VAR" >i</field>
                  <value name="FROM">
                  </value>
                  <value name="TO">
                  </value>
                  <value name="BY">
                  </value>
                </block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
              </xml>`
  }
];

class LevelRepository {
  getLevels() {
    return levels;
  }

  getLevel(level) {
    let levelNumber = parseInt(level);
    return levels[levelNumber - 1];
  }
}

export default new LevelRepository();
